export default {
  common: {
    pageNotFound: 'Page not found',
    backToHome: 'Back to Home',
  },
  nav: {
    services: 'Services',
    pricing: 'Pricing',
    contact: 'Contact',
    getStarted: 'Get Started',
  },
  hero: {
    title: 'Fresh Macro-Balanced Meals Delivered Daily',
    subtitle: 'Premium meal delivery service with perfectly calculated macros. Fresh, healthy, and delicious meals crafted by nutrition experts and delivered to your door.',
    startJourney: 'Order Now',
    learnMore: 'View Menu',
    imageAlt: 'Fresh macro-balanced meal delivery',
    statsTitle: '50,000+ Meals Delivered',
    statsSubtitle: 'Happy customers nationwide',
  },
  services: {
    title: 'Why Choose MacroFit Meals',
    subtitle: 'We make healthy eating simple with chef-prepared, macro-balanced meals delivered fresh to your door.',
    nutrition: {
      title: 'Macro-Balanced Nutrition',
      description: 'Every meal is carefully crafted with precise macro calculations to support your fitness goals.',
      feature1: 'Certified nutritionist approved',
      feature2: 'Precise macro calculations',
      feature3: 'Goal-specific meal plans',
    },
    tracking: {
      title: 'Fresh Daily Delivery',
      description: 'Farm-to-table ingredients prepared fresh daily and delivered to your door with flexible scheduling.',
      feature1: 'Same-day preparation',
      feature2: 'Eco-friendly packaging',
      feature3: 'Flexible delivery windows',
    },
    delivery: {
      title: 'Chef-Prepared Quality',
      description: 'Professional chefs create restaurant-quality meals using premium ingredients and proven recipes.',
      feature1: 'Gourmet chef recipes',
      feature2: 'Premium ingredients only',
      feature3: 'Restaurant-quality taste',
    },
  },
  pricing: {
    title: 'Choose Your Meal Plan',
    subtitle: 'Flexible meal plans designed to fit your lifestyle and budget. All meals include detailed macro information.',
    popular: 'Most Popular',
    getStarted: 'Start Plan',
    basic: {
      name: 'Starter Plan',
      period: 'week',
      description: 'Perfect for trying our service',
      feature1: '5 meals per week',
      feature2: 'Basic macro tracking',
      feature3: 'Standard delivery',
      feature4: 'Email support',
    },
    pro: {
      name: 'Fitness Plan',
      period: 'week',
      description: 'Ideal for active individuals',
      feature1: '10 meals per week',
      feature2: 'Advanced macro tracking',
      feature3: 'Priority delivery',
      feature4: 'Chat support',
      feature5: 'Custom meal preferences',
    },
    elite: {
      name: 'Performance Plan',
      period: 'week',
      description: 'Complete nutrition solution',
      feature1: '15 meals per week',
      feature2: 'Premium macro optimization',
      feature3: 'Same-day delivery',
      feature4: '24/7 phone support',
      feature5: 'Personal nutrition coach',
      feature6: 'Unlimited meal swaps',
    },
  },
  contact: {
    title: 'Ready to Start Your MacroFit Journey?',
    subtitle: 'Join thousands of satisfied customers who have transformed their nutrition with our fresh, macro-balanced meals.',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    form: {
      name: 'Full Name',
      namePlaceholder: 'Enter your full name',
      email: 'Email Address',
      emailPlaceholder: 'Enter your email address',
      phone: 'Phone Number',
      phonePlaceholder: 'Enter your phone number',
      goal: 'Fitness Goal',
      goalPlaceholder: 'Select your primary goal',
      goals: {
        weightLoss: 'Weight Loss',
        muscleGain: 'Muscle Gain',
        maintenance: 'Weight Maintenance',
        performance: 'Athletic Performance',
      },
      message: 'Special Dietary Requirements',
      messagePlaceholder: 'Tell us about any allergies, dietary restrictions, or meal preferences...',
      charactersRemaining: 'characters remaining',
      submit: 'Get Started',
      sending: 'Processing...',
      successMessage: 'Welcome to MacroFit Meals! We\'ll contact you within 24 hours to set up your meal plan.',
      errorMessage: 'Sorry, there was an error processing your request. Please try again or call us directly.',
    },
  },
  footer: {
    description: 'MacroFit Meals delivers fresh, chef-prepared, macro-balanced meals to fuel your fitness journey. Premium ingredients, precise nutrition, exceptional taste.',
    services: 'Services',
    nutritionConsulting: 'Meal Plans',
    macroTracking: 'Macro Tracking',
    mealDelivery: 'Fresh Delivery',
    personalTraining: 'Nutrition Coaching',
    company: 'Company',
    aboutUs: 'About Us',
    careers: 'Careers',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    copyright: 'All rights reserved.',
  },
};